import { useQuery } from '@tanstack/react-query';
import { fetchSecurityGroup } from '../services/security-groups';

export function useSecurityGroupQuery(id: string | undefined) {
  return useQuery({
    queryKey: ['security-group', id],
    queryFn: () => fetchSecurityGroup(id!),
    enabled: !!id,
  });
}
